import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a81870dbedae70014dbcafd_1788351663344_12d7e2d5/mygcc/src/app/customer-360/components/Customer360Content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a81870dbedae70014dbcafd_1788351663344_12d7e2d5/mygcc/src/components/AppLayout.tsx");
